/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_TitleInputs */

const cs_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úlohy na pozadí`)
};

const en_jobs_title = /** @type {(inputs: Jobs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background jobs`)
};

/**
* | output |
* | --- |
* | "Background jobs" |
*
* @param {Jobs_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_title = /** @type {((inputs?: Jobs_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_title(inputs)
	return cs_jobs_title(inputs)
});